var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        _this.el = null;
        _this.overlayRef = React.createRef();
        _this.onOverlayClick = function (e) {
            if (e.target == _this.overlayRef.current)
                _this.ownProps.onOverlayClick();
        };
        _this.el = getContainer(_this.ownProps.container);
        return _this;
    }
    Object.defineProperty(Portal.prototype, "ownProps", {
        get: function () {
            return this.props;
        },
        enumerable: false,
        configurable: true
    });
    Portal.prototype.componentDidMount = function () {
        this.el = getContainer(this.ownProps.container);
    };
    Portal.prototype.componentDidUpdate = function () {
        this.el = getContainer(this.ownProps.container);
    };
    Portal.prototype._getOverlay = function () {
        if (!this.props.children)
            return null;
        return (React.createElement("div", { ref: this.overlayRef, className: this.ownProps.className, onClick: this.onOverlayClick, style: this.ownProps.style }, this.ownProps.children));
    };
    Portal.prototype.render = function () {
        if (!this.el)
            return null;
        var children = this._getOverlay();
        return children && ReactDOM.createPortal(children, this.el);
    };
    Portal.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        container: PropTypes.any,
        style: PropTypes.object,
        onOverlayClick: PropTypes.func
    };
    Portal.defaultProps = {
        className: '',
        onOverlayClick: function () { }
    };
    return Portal;
}(Component));
function getContainer(container) {
    var _container = typeof container === 'function' ? container() : container;
    return (ReactDOM.findDOMNode(_container) || document.body);
}
export { Portal };
